export default "__VITE_ASSET__DTbL4D7K__"